import { registerMockAPI } from '~/mocks/mockApis';

import { axiosInstance } from '~/services';

import type {
  TypeGetOwnerSupplierOwnerSupplierCodeParams,
  TypeGetOwnerSupplierOwnerSupplierCodeResponse,
} from '~/types/vender.types';

/**
 * [화주사정보관리 > 공급사관리] 공급사 상세 조회
 */
const useGetOwnerSupplierOwnerSupplierCode = () => {
  const endPoint = '/api-owner/owner-supplier';

  const getOwnerSupplierOwnerSupplierCode = async ({
    ownerSupplierCode,
  }: TypeGetOwnerSupplierOwnerSupplierCodeParams) => {
    return axiosInstance
      .get<TypeGetOwnerSupplierOwnerSupplierCodeResponse>(`${endPoint}/${ownerSupplierCode}`)
      .then(({ data }) => {
        return data.data;
      })
      .catch((error) => {
        throw error;
      });
  };

  return { getOwnerSupplierOwnerSupplierCode };
};

export default useGetOwnerSupplierOwnerSupplierCode;

const ownerSupplierDetailResponse: TypeGetOwnerSupplierOwnerSupplierCodeResponse = {
  data: {
    ownerSupplierCode: 'SU000005',
    ownerOriginSupplierCode: 'ORIGIN-005',
    businessNumber: '1234567890',
    businessNumberChecked: true,
    ownerSupplierName: '[e2e] 신선농산 주식회사',
    businessConditions: '도소매',
    businessCategory: '농산물',
    ceoName: '홍길동',
    zipCode: '10545',
    address: '경기도 김포시 김포한강9로 76',
    detailAddress: '신선농산 본사',
    ownerSupplierTel: '02-1234-5678',
    ownerSupplierFax: '02-1234-5679',
    dealStartDate: '2026-01-01',
    dealEndDate: null,
    useStatus: 'Y',
    useKurlyPickup: false,
    useMilkRunPickup: false,
    sameShippingAddress: false,
    ownerSupplierShippingAddressDetailList: [],
    ownerSupplierManagerList: [
      {
        ownerSupplierManagerId: 51,
        ownerSupplierCode: 'SU000005',
        ownerSupplierManagerName: '김대표',
        ownerSupplierManagerPosition: '대표',
        ownerSupplierManagerTel: '010-1111-2222',
        ownerSupplierManagerEmail: 'ceo@e2e-supplier.com',
      },
      {
        ownerSupplierManagerId: 52,
        ownerSupplierCode: 'SU000005',
        ownerSupplierManagerName: '이담당',
        ownerSupplierManagerPosition: '과장',
        ownerSupplierManagerTel: '010-3333-4444',
        ownerSupplierManagerEmail: 'manager@e2e-supplier.com',
      },
      {
        ownerSupplierManagerId: 53,
        ownerSupplierCode: 'SU000005',
        ownerSupplierManagerName: '박사원',
        ownerSupplierManagerPosition: '',
        ownerSupplierManagerTel: '010-5555-6666',
        ownerSupplierManagerEmail: '',
      },
    ],
  },
};

registerMockAPI<TypeGetOwnerSupplierOwnerSupplierCodeResponse>({
  method: 'get',
  endpoint: '/api-owner/owner-supplier/:ownerSupplierCode',
  label: '화주사정보/공급사관리/공급사상세',
  scenarios: [{ name: '정상 응답 — 담당자 3명', response: ownerSupplierDetailResponse }],
});
